module.exports = __webpack_public_path__ + "static/the-art-lesson-bd7c10e2c896cca1e0b4867b5193dc05.jpg";